import { lazy, Suspense } from "react";

import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

// Reachability stays on App.js protectedElement developmentMode — not this wrapper.
const CasinoPreviewPage = lazy(() => import("./Preview"));

export function CasinoPreviewSuspenseFallback() {
  return (
    <div
      className="loading-container"
      data-testid="casino-preview-lazy-fallback"
    >
      <RebetLoader height="32px" width="32px" />
    </div>
  );
}

export default function CasinoPreviewLazyRoute() {
  return (
    <Suspense fallback={<CasinoPreviewSuspenseFallback />}>
      <CasinoPreviewPage />
    </Suspense>
  );
}
